class ComparativeCard extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('[data-button]');
    this.contentElements = this.querySelectorAll('[data-content]');
    this.defaultButton = parseInt(this.dataset.defaultButton) || 1;

    // Initialize with default button active
    this.init();

    // Add click listeners to buttons
    if (this.buttons && this.buttons.length > 0) {
      this.buttons.forEach((button, index) => {
        if (button) {
          button.addEventListener('click', () => this.handleButtonClick(index));
        }
      });
    }
  }

  init() {
    // Set default button as active (default_button is 1-indexed)
    if (this.buttons && this.buttons.length > 0) {
      const defaultIndex = this.defaultButton - 1;
      if (this.buttons[defaultIndex]) {
        this.setActiveButton(defaultIndex);
      }
    }
  }

  handleButtonClick(buttonIndex) {
    this.setActiveButton(buttonIndex);
  }

  setActiveButton(buttonIndex) {
    // Remove data-active from all buttons
    if (this.buttons && this.buttons.length > 0) {
      this.buttons.forEach(button => {
        if (button) {
          button.removeAttribute('data-active');
        }
      });
    }

    // Remove data-active from all content elements
    if (this.contentElements && this.contentElements.length > 0) {
      this.contentElements.forEach(content => {
        if (content) {
          content.removeAttribute('data-active');
        }
      });
    }

    // Add data-active to clicked button
    if (this.buttons && this.buttons[buttonIndex]) {
      this.buttons[buttonIndex].setAttribute('data-active', '');
    }

    // Add data-active to corresponding content element
    if (this.contentElements && this.contentElements[buttonIndex]) {
      this.contentElements[buttonIndex].setAttribute('data-active', '');
    }
  }
}

customElements.define('comparative-card', ComparativeCard);
